import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import { detectionIcons } from "../../../../stack/environment/icons/iconExport";
import { FieldsSettingsContext } from "../../CustomNotificationPage";
import { field_IDs_mapping } from "../../fieldMapping";
import SettingsList from "../components/SettingsList";
import SettingsSection from "../components/SettingsSection";

export default function DetectionsNotificationsSection() {
  const colors = useColors();
  const [fetchStatus, setFetchStatus] = useState(null);
  const getFieldsSettingsData = useContext(FieldsSettingsContext);

  const detectionsFields = field_IDs_mapping.DETECTIONS;

  const settingsFieldIDs = [
    detectionsFields.SEVERITY_HIGH,
    detectionsFields.SEVERITY_MEDIUM,
    detectionsFields.SEVERITY_LOW,
    detectionsFields.AFFECTING_CRITICAL_ASSET,
  ];

  const settingsData = getFieldsSettingsData(settingsFieldIDs);

  return (
    <SettingsSection
      title="Active Detections"
      Icon={detectionIcons.DetectionBlack}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <Grid container direction="column" gap={0.5}>
        <Grid item>
          <Grid container direction="row" gap={1} alignItems="center">
            <Typography variant="subtitle2" color={colors.text_primary}>
              Event Severity
            </Typography>
            <CustomToolTip
              title={
                "The severity levels of active detections you want to be notified about"
              }
              style={{ maxWidth: "500px" }}
            >
              <HelpOutlineIcon
                sx={{
                  color: colors.text_secondary,
                  width: "12px",
                  height: "12px",
                }}
              />
            </CustomToolTip>
          </Grid>
        </Grid>
        <Grid item mb={1}>
          <SettingsList
            settingsData={settingsData}
            setFetchStatus={setFetchStatus}
          />
        </Grid>
      </Grid>
    </SettingsSection>
  );
}
